import moment from 'moment'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, Switch, Route } from 'react-router-dom'
import { Badge, DatePicker, Menu, Dropdown,Popconfirm } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useToggle, usePet } from '../../modules'

import Confirm from '../../components/reusable/confirm'
import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

import NewPatient from '../../components/drawers/newPatient'
import PatientDetails from '../../components/drawers/patient'
import UploadAttachment from '../../components/drawers/uploadAttachment'
// import IssueFile from '../../components/drawers/issueFile'

const { RangePicker } = DatePicker

const Patients = () => {
    const [ranges, setRanges] = useState()
    const [chosen, setChosen] = useState([])
    const [departments, setDepartments] = useState([])
    const [department, setDepartment] = useState()
    const [string, setString] = useState('')
    const [selected, setSelected] = useState('')
    
    const [newpatient, toggleNewPatient] = useToggle()
    const [select, toggleSelect] = useToggle()

    const [
        { loading: pLoading, error: pError, fetch: fetchPatients },
        { list: patients },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('patients', ranges ? { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { string }, { notify: true })

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        fetchPatients()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    
    }

    const onComplete = (_, notif, ops) => {
        notif('Id No has been assigned', ops('success'))
        fetchPatients()
    }

    const [, assignIdNo] = usePet('assignId', {
        patient: selected,
        department
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Assigning ip no...' } })

    usePet('departments', {}, { notify: true, callback: ({ data }) => {
        data = data.filter(dept => dept.requiresId)
        setDepartments(data)
    } })

    const assignId = (id, dept) => {
        setSelected(id)
        setDepartment(dept)
        assignIdNo()        
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                {
                    newpatient &&
                    <NewPatient
                        path="/app/records"
                        onPerform={ refresh }
                        toggle={ toggleNewPatient }
                        visible={ newpatient }/>
                }
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker 
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}/>
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => null}>Patient Visits</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Patients</h2>
                    <span className="flex items-center justify-between">
                        <button onClick={ toggleNewPatient } className="btn ml-2 hisani-btn-green-light text-white">
                            <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                            </svg>
                            <span className="hidden xs:block ml-2">New Patient</span>
                        </button>
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        loading={pLoading}
                        error={pError}>
                        {
                            patients?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">File Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Added On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Latest Visit</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patients.map((patient, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select ?
                                                                        <input
                                                                            onChange={() => choose(patient._id)}
                                                                            checked={chosen.includes(patient._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="flex space-x-2 pl-1 items-center">
                                                                <div className={ `w-2 h-2 rounded-full bg-${ patient.fileIssued? 'yellow' : 'green'}-500 shadow` }></div>
                                                                <p className={ `text-${ patient.fileIssued? 'yellow' : 'green'}-500 text-xs italic mb-0` }>{ patient.fileIssued ? 'Issued' : 'In Storage' }</p>
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `/app/records/patients/${patient._id}` }><Menu.Item>Details</Menu.Item></Link>
                                                                        {
                                                                            departments
                                                                                .filter(d => !patient[d.idProperty])
                                                                                .map(d =>
                                                                                    <Menu.Item onClick={ () => Confirm({
                                                                                        title: `Assign ${d.name} Id?`,
                                                                                        message: 'Please confirm before performing this action',
                                                                                        okText: `Assign ${d.name} Id?`,
                                                                                        onOk: () => assignId(patient._id, d._id)
                                                                                    }) }>Assign {d.name} Id</Menu.Item>
                                                                                )
                                                                        }
                                                                        <Link to={ `/app/records/patients/${patient._id}/upload-attachment` }><Menu.Item>Upload Attachment</Menu.Item></Link>
                                                                        <Link to={ `/app/records/patients/${patient._id}/issue-file` }><Menu.Item>{ patient.fileIssued ? 'Receive File' : 'Issue File' }</Menu.Item></Link>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">You can add a new patient by clicking above</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route exact path="/app/records/patients/:id">
                    <PatientDetails reload={ refresh } source="/app/records" />
                </Route>
                <Route exact path="/app/records/patients/:id/upload-attachment">
                    <UploadAttachment reload={ refresh } source="/app/records/patients" />
                </Route>
                {/* <Route exact path="/app/records/patients/:id/issue-file">
                    <IssueFile reload={ refresh } source="/app/records" />
                </Route> */}
            </Switch>
        </div>       
    )
}

export default Patients